import { Switch, Route, Redirect } from 'react-router-dom';
import React from 'react';
// Contexts
import { ProjectProvider } from './contexts/ProjectsContext';
// Custom Routes
const PublicRoute = React.lazy(() => import('./custom-routes/PublicRoute'));
const DashboardRoute = React.lazy(() =>
  import('./custom-routes/DashboardRoute')
);
const ProjectRoute = React.lazy(() => import('./custom-routes/ProjectRoute'));

// Authentification Pages
const Login = React.lazy(() => import('./view/auth/login'));
const Register = React.lazy(() => import('./view/auth/register'));
const ResetPassword = React.lazy(() => import('./view/auth/reset-password'));
const EmailVerification = React.lazy(() =>
  import('./view/auth/email-verification')
);

// Inside Project Pages
const Persons = React.lazy(() => import('./view/projects/persons'));
const Companies = React.lazy(() => import('./view/projects/companies'));
const Events = React.lazy(() => import('./view/projects/events'));
const SpecificPerson = React.lazy(() =>
  import('./view/projects/specificPerson')
);
const SpecificCompany = React.lazy(() =>
  import('./view/projects/specificCompany')
);

const MentionAnalytics = React.lazy(() =>
  import('./view/projects/mentionAnalytics')
);
const SpecificEvent = React.lazy(() => import('./view/projects/specificEvent'));
const Graph = React.lazy(() => import('./view/projects/graph'));

// Dashboard Pages
const ProjectsList = React.lazy(() => import('./view/dashboard/projects'));
const MyAccount = React.lazy(() => import('./view/dashboard/account'));
const AdminPanel = React.lazy(() => import('./view/dashboard/admin-panel'));

//terms and conditions
const Privacy = React.lazy(() =>
  import('./view/auth/privacyAndCondition/PrivacyView')
);
const TermsCondition = React.lazy(() =>
  import('./view/auth/privacyAndCondition//TermsConditions')
);

const ProjectsWithContext = () => (
  <ProjectProvider>
    <ProjectsList />
  </ProjectProvider>
);

const MyAccountWithContext = () => (
  <ProjectProvider>
    <MyAccount />
  </ProjectProvider>
);

const LoginWithContext = () => (
  <ProjectProvider>
    <Login />
  </ProjectProvider>
);

const Routes = () => {
  return (
    <Switch>
      <Route exact path="/" render={() => <Redirect to="/projects" />} />
      <PublicRoute exact path="/login" component={LoginWithContext} />
      <PublicRoute exact path="/register" component={Register} />
      <PublicRoute exact path="/privacyPolicy" component={Privacy} />
      <PublicRoute exact path="/termsConditions" component={TermsCondition} />
      <PublicRoute
        exact
        path="/reset-password/:hash"
        component={ResetPassword}
      />
      <PublicRoute
        exact
        path="/email-verification"
        component={EmailVerification}
      />
      <ProjectRoute exact path="/:project/graph" component={Graph} />
      <ProjectRoute exact path="/:project/persons" component={Persons} />
      <ProjectRoute exact path="/:project/companies" component={Companies} />
      <ProjectRoute exact path="/:project/events" component={Events} />
      <ProjectRoute
        exact
        path="/:project/analytics"
        component={MentionAnalytics}
      />
      <ProjectRoute
        exact
        path="/:project/person/:id/:api"
        component={SpecificPerson}
      />
      <ProjectRoute
        exact
        path="/:project/company/:id"
        component={SpecificCompany}
      />
      <ProjectRoute
        exact
        path="/:project/event/:id"
        component={SpecificEvent}
      />
      <DashboardRoute exact path="/projects" component={ProjectsWithContext} />
      <DashboardRoute
        exact
        path="/my-account"
        component={MyAccountWithContext}
      />
      <DashboardRoute exact path="/admin-panel" component={AdminPanel} />
      <Route exact path="*" render={() => <Redirect to="/projects" />} />
    </Switch>
  );
};

export default Routes;
